import React from 'react';
import { Stack, useTheme } from '@mui/material';

const BackgroundContainer = ({ children, direction = 'column', sx = {}, spacing = 1 }) => {
    const theme = useTheme();

    return (
        <Stack 
            direction={direction} 
            sx={{
                border: `${theme.palette.customColors.darkBackground.borderColor}`,
                bgcolor: theme.palette.customColors.lightBackground,
                ...sx,  // Merge the passed sx prop with default styles
            }}
            spacing={spacing}  // Pass the spacing prop directly to the Stack
        >
            {children}
        </Stack>
    );
};

export default BackgroundContainer;
